<template>
  <div
    class="home"
  >
    <!-- 显示引导 showMask-->
    <view v-if="showMask" class="img-box" @click="closeMask">
      <image src="/static/guide.png" class="guide-img" mode="widthFix"></image>
    </view>
  </div>
</template>

<script>
import { setNavigationBar } from "@/utils/hybrid";
import { openApp } from '@/utils'

export default {
  name: "OpenApp",

  data() {
    return {
      showMask: false,
    };
  },

  mounted() {
    document.tilte = "\u200E";
    setNavigationBar({
      title: '\u200E',
    });
    this.handleOpenApp();
  },

  methods: {
    handleOpenApp() {
      const searchParams = window.location.search;
      const flag = openApp(`${searchParams}`);

      if (flag) {
        this.showMask = true;
      }
    },
    closeMask() {
      this.showMask = false;
    }
  }
};
</script>
